import React from 'react';
import { BOX_IMG, BUY_ANCHOR } from './constants';
interface ProductImageProps {
  className?: string;
}
export function ProductImage({
  className = ''
}: ProductImageProps) {
  return <a href={BUY_ANCHOR} className="block cursor-pointer" data-id="element-137" data-mp="2llpyx6b6by6s">
      <img src={BOX_IMG} alt="SENIOR FITNESS PRO — Système complet de planification 6-en-1" className={`w-full h-auto object-contain mx-auto drop-shadow-xl hover:scale-[1.02] transition-transform duration-300 ${className}`} data-id="element-138" data-mp="2lk55xl4icnb1" />
    </a>;
}